import React from 'react';
import {
    Users, Truck, Settings, CheckCircle, TrendingUp, TrendingDown,
    Activity, AlertCircle, Clock, Star, FilePlus, Percent
} from 'lucide-react';

const iconMap = {
    users: Users,
    truck: Truck,
    clock: Settings,
    'check-circle': CheckCircle,
    timer: Clock,
    star: Star,
    'file-plus': FilePlus,
    percent: Percent,
};

const colorMap = {
    blue: 'bg-orange-500 text-white',
    green: 'bg-purple-500 text-white',
    yellow: 'bg-rose-500 text-white',
    cyan: 'bg-cyan-500 text-white',
    red: 'bg-red-100 text-red-600',
    indigo: 'bg-indigo-500 text-white',
    amber: 'bg-amber-500 text-white',
};

const formatDisplayValue = (value) => {
    if (value === null || value === undefined) return '—';
    if (typeof value === 'number' && !Number.isInteger(value)) {
        return Number(value).toLocaleString(undefined, { maximumFractionDigits: 1 });
    }
    if (typeof value === 'number') {
        return value.toLocaleString();
    }
    return value;
};

const StatsCard = ({ title, value, icon, trend, subtitle, percentage, color = 'blue', valueSuffix = '', trendLabel = 'vs last month' }) => {
    const Icon = iconMap[icon] || Activity;
    const colorClass = colorMap[color] || colorMap.blue;
    const trendPositive = trend !== undefined && trend !== null && trend >= 0;

    return (
        <div className="bg-white rounded-xl bxshadow p-6 border bxshadowhd">
            <div className="flex items-center justify-between-center">
                <div className={`p-3 borderfull mrg-10 rounded-lg ${colorClass}`}>
                    <Icon className="iconsw" />
                </div>
                <div className="float-left min-w-0">
                    <p className="text-1xl font-bold text-gray-600">{title}</p>
                    <p className="text-xl font-bold text-gray-900 truncate">
                        {formatDisplayValue(value)}
                        {valueSuffix ? (
                            <span className="text-sm font-medium text-gray-500 ml-1">{valueSuffix}</span>
                        ) : null}
                    </p>
                </div>
            </div>
            <div className="mt-4 flex items-center text-sm text-gray-600 bodertop flex-wrap gap-1">
                {trend !== undefined && trend !== null && (
                    <>
                        {trendPositive ? (
                            <TrendingUp className="w-4 h-4 text-green-500 mr-1" />
                        ) : (
                            <TrendingDown className="w-4 h-4 text-red-500 mr-1" />
                        )}
                        <span className={`font-medium ${trendPositive ? 'text-green-600' : 'text-red-600'}`}>
                            {trendPositive ? '+' : ''}{trend}%
                        </span>
                        <span className="ml-1">{trendLabel}</span>
                    </>
                )}
                {subtitle && (
                    <>
                        {icon === 'truck' && <Activity className="w-4 h-4 text-blue-500 mr-1" />}
                        {icon === 'clock' && <AlertCircle className="w-4 h-4 text-yellow-500 mr-1" />}
                        <span>{subtitle}</span>
                    </>
                )}
                {percentage !== undefined && percentage !== null && (
                    <>
                        <span className="text-green-600 font-medium">{percentage}%</span>
                        <span className="ml-1">completion rate</span>
                    </>
                )}
            </div>
        </div>
    );
};

export default StatsCard;
